<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>
    Sie haben verschiedene Behandlungen versucht, die bestenfalls für einige Wochen gewirkt, am Ende
    aber nichts verändert haben?
  </p>
</QuestionFrame>
